<template>
	<div class="carousel swiper" ref="carousel">
		<ul class="swiper-wrapper">
			<slot></slot>
		</ul>
		<div class="swiper-pagination"></div>
	</div>
</template>
<script setup>
import Swiper from 'swiper/bundle';
import {ref, onMounted} from 'vue';

const props = defineProps(['gap']);

const carousel = ref(null);
const isDesktop = ref(false);
let swiper = null;
let loop = false;

const initSwiper = () => {
	swiper = new Swiper(carousel.value, {
        slidesPerView:1.5,
		slidesPerGroup:1,
        centeredSlides:true,
        loop:loop,
        spaceBetween:props.gap !== undefined ? props.gap : 16,
		effect:'coverflow',
		initialSlide: 0,
		coverflowEffect:{
			rotate:0,
			slideShadows:false,
			stretch: -1 * (props.gap !== undefined ? props.gap : 16)
		},
		pagination: {
			el: carousel.value.querySelector('.swiper-pagination'),
			clickable:true,
			bulletElement:'button'
		},
        breakpoints:{
            768:{
                slidesPerView:4,
				slidesPerGroup:4,
				centeredSlides:false,
				loop:false,
				coverflowEffect:false,
				effect:'slide',

            }
        }
    });

	if(!isDesktop.value && swiper.slides.length < 5){
		swiper.slideToLoop()
		//swiper.
	}
}


if(window.innerWidth >= 768){
	isDesktop.value = true;
}

onMounted(() => {
	loop = carousel.value.querySelectorAll('.swiper-slide').length > 4 ? true : false;
	console.log(loop);
    initSwiper();

	window.addEventListener('resize', () => {
		if(window.innerWidth >= 768 && !isDesktop.value){
			swiper.destroy(true, true);
			initSwiper();
		} else if(window.innerWidth < 768 && isDesktop.value){
			isDesktop.value = false;
		}
	}, false)
});


</script>
